import { StanButton, StanCard } from '@/components';
import { useEffect, useState } from 'react';
import { useUser } from '@/queries/useUser';
import { useAuthStore } from '@/stores';
import { copyToClipboard } from '@/lib';
import { generateReferralUrl } from '../logic/referrals.logic';
import { ReferralEarningsChart } from './ReferralEarningsChart';

export const ReferralBanner = () => {
    const [hasReferralLink, setHasReferralLink] = useState(false);
    const [referralUrl, setReferralUrl] = useState('');
    const { isUserLoading } = useUser();
    const { currentAccount } = useAuthStore();
    const accountData = currentAccount();

    // Generate referral URL when user data is available
    useEffect(() => {
        if (accountData?.username) {
            const generatedUrl = generateReferralUrl(accountData.username, false); // false for staging
            setReferralUrl(generatedUrl);
        }
    }, [accountData?.username]);

    const handleCreateReferral = () => {
        setHasReferralLink(true);
    };

    const handleCopyLink = () => {
        copyToClipboard(referralUrl, {
            successMessage: 'Referral link copied to clipboard',
            errorMessage: 'Failed to copy link to clipboard',
        });
    };

    return (
        <StanCard className='w-full'>
            <div className='flex w-full flex-col items-start justify-between gap-8 md:flex-row md:items-center'>
                {/* Left Section - Referral Link */}
                <div className='flex w-full shrink-0 flex-col gap-4 md:w-auto'>
                    <h2 className='text-dark text-heading-h2'>Share your referral link</h2>
                    {isUserLoading ? (
                        <div className='text-gray text-label-sm-regular'>Loading...</div>
                    ) : !hasReferralLink ? (
                        <StanButton name='create-referral' onClick={handleCreateReferral} color='primary' size='md'>
                            Create Your Referral Code
                        </StanButton>
                    ) : (
                        <div className='flex flex-col gap-3 md:flex-row md:items-center'>
                            <div className='bg-neutral-subtle text-brand-main text-label-sm-bold overflow-hidden rounded-lg px-4 py-3 text-ellipsis whitespace-nowrap'>
                                {referralUrl}
                            </div>
                            <StanButton
                                name='copy-referral-link'
                                onClick={handleCopyLink}
                                color='secondary'
                                size='md'
                                className='shrink-0'
                            >
                                Copy
                            </StanButton>
                        </div>
                    )}
                </div>

                {/* Right Section - Earnings Chart */}
                <div className='w-full shrink-0 md:w-96'>
                    <ReferralEarningsChart
                        barCount={8}
                        ratePerCreator={6}
                        initialCreatorCount={2}
                        minCreators={0}
                        maxCreators={10}
                        showTitle={false}
                    />
                </div>
            </div>
        </StanCard>
    );
};
